require("core-js/modules/es6.object.define-property");

var $CLJS = require("./cljs_env");

var $jscomp = $CLJS.$jscomp;
var COMPILED = false;

require("./cljs.core.js");

require("./cljs.core.async.impl.protocols.js");

require("./cljs.core.async.impl.channels.js");

require("./cljs.core.async.impl.dispatch.js");

var edn_query_language = $CLJS.edn_query_language || ($CLJS.edn_query_language = {});
var module$shadow_js_shim_module$react = $CLJS.module$shadow_js_shim_module$react || ($CLJS.module$shadow_js_shim_module$react = {});
var clojure = $CLJS.clojure || ($CLJS.clojure = {});
var cljs = $CLJS.cljs || ($CLJS.cljs = {});
var shadow = $CLJS.shadow || ($CLJS.shadow = {});
var module$shadow_js_shim_module$react_dom = $CLJS.module$shadow_js_shim_module$react_dom || ($CLJS.module$shadow_js_shim_module$react_dom = {});
var helix = $CLJS.helix || ($CLJS.helix = {});
var goog = $CLJS.goog || ($CLJS.goog = {});
var module$shadow_js_shim_module$$nivo$line = $CLJS.module$shadow_js_shim_module$$nivo$line || ($CLJS.module$shadow_js_shim_module$$nivo$line = {});
var expound = $CLJS.expound || ($CLJS.expound = {});
var module$shadow_js_shim_module$$nivo$bar = $CLJS.module$shadow_js_shim_module$$nivo$bar || ($CLJS.module$shadow_js_shim_module$$nivo$bar = {});
var cljs_bean = $CLJS.cljs_bean || ($CLJS.cljs_bean = {});
var promesa = $CLJS.promesa || ($CLJS.promesa = {});
var com = $CLJS.com || ($CLJS.com = {});
$CLJS.SHADOW_ENV.setLoaded("cljs.core.async.impl.timers.js");
goog.provide('cljs.core.async.impl.timers');
cljs.core.async.impl.timers.MAX_LEVEL = 15;
cljs.core.async.impl.timers.P = 1 / 2;

cljs.core.async.impl.timers.random_level = function cljs$core$async$impl$timers$random_level(var_args) {
  var G__26210 = arguments.length;

  switch (G__26210) {
    case 0:
      return cljs.core.async.impl.timers.random_level.cljs$core$IFn$_invoke$arity$0();
      break;

    case 1:
      return cljs.core.async.impl.timers.random_level.cljs$core$IFn$_invoke$arity$1(arguments[0]);
      break;

    default:
      throw new Error(["Invalid arity: ", cljs.core.str.cljs$core$IFn$_invoke$arity$1(arguments.length)].join(''));
  }
};

cljs.core.async.impl.timers.random_level.cljs$core$IFn$_invoke$arity$0 = function () {
  return cljs.core.async.impl.timers.random_level.cljs$core$IFn$_invoke$arity$1(0);
};

cljs.core.async.impl.timers.random_level.cljs$core$IFn$_invoke$arity$1 = function (level) {
  while (true) {
    if (Math.random() < cljs.core.async.impl.timers.P && level < cljs.core.async.impl.timers.MAX_LEVEL) {
      var G__26225 = level + 1;
      level = G__26225;
      continue;
    } else {
      return level;
    }

    break;
  }
};

cljs.core.async.impl.timers.random_level.cljs$lang$maxFixedArity = 1;
/**
* @constructor
 * @implements {cljs.core.ISeqable}
 * @implements {cljs.core.IPrintWithWriter}
*/

cljs.core.async.impl.timers.SkipListNode = function (key, val, forward) {
  this.key = key;
  this.val = val;
  this.forward = forward;
  this.cljs$lang$protocol_mask$partition0$ = 2155872256;
  this.cljs$lang$protocol_mask$partition1$ = 0;
};

cljs.core.async.impl.timers.SkipListNode.prototype.cljs$core$ISeqable$_seq$arity$1 = function (coll) {
  var self__ = this;
  var coll__$1 = this;
  return new cljs.core.List(null, self__.key, new cljs.core.List(null, self__.val, null, 1, null), 2, null);
};

cljs.core.async.impl.timers.SkipListNode.prototype.cljs$core$IPrintWithWriter$_pr_writer$arity$3 = function (coll, writer, opts) {
  var self__ = this;
  var coll__$1 = this;
  return cljs.core.pr_sequential_writer(writer, cljs.core.pr_writer, "[", " ", "]", opts, coll__$1);
};

cljs.core.async.impl.timers.SkipListNode.getBasis = function () {
  return new cljs.core.PersistentVector(null, 3, 5, cljs.core.PersistentVector.EMPTY_NODE, [new cljs.core.Symbol(null, "key", "key", 124488940, null), cljs.core.with_meta(new cljs.core.Symbol(null, "val", "val", 1769233139, null), new cljs.core.PersistentArrayMap(null, 1, [new cljs.core.Keyword(null, "mutable", "mutable", 875778266), true], null)), new cljs.core.Symbol(null, "forward", "forward", 1083186224, null)], null);
};

cljs.core.async.impl.timers.SkipListNode.cljs$lang$type = true;
cljs.core.async.impl.timers.SkipListNode.cljs$lang$ctorStr = "cljs.core.async.impl.timers/SkipListNode";

cljs.core.async.impl.timers.SkipListNode.cljs$lang$ctorPrWriter = function (this__4369__auto__, writer__4370__auto__, opt__4371__auto__) {
  return cljs.core._write(writer__4370__auto__, "cljs.core.async.impl.timers/SkipListNode");
};
/**
 * Positional factory function for cljs.core.async.impl.timers/SkipListNode.
 */


cljs.core.async.impl.timers.__GT_SkipListNode = function cljs$core$async$impl$timers$__GT_SkipListNode(key, val, forward) {
  return new cljs.core.async.impl.timers.SkipListNode(key, val, forward);
};

cljs.core.async.impl.timers.skip_list_node = function cljs$core$async$impl$timers$skip_list_node(var_args) {
  var G__26212 = arguments.length;

  switch (G__26212) {
    case 1:
      return cljs.core.async.impl.timers.skip_list_node.cljs$core$IFn$_invoke$arity$1(arguments[0]);
      break;

    case 3:
      return cljs.core.async.impl.timers.skip_list_node.cljs$core$IFn$_invoke$arity$3(arguments[0], arguments[1], arguments[2]);
      break;

    default:
      throw new Error(["Invalid arity: ", cljs.core.str.cljs$core$IFn$_invoke$arity$1(arguments.length)].join(''));
  }
};

cljs.core.async.impl.timers.skip_list_node.cljs$core$IFn$_invoke$arity$1 = function (level) {
  return cljs.core.async.impl.timers.skip_list_node.cljs$core$IFn$_invoke$arity$3(null, null, level);
};

cljs.core.async.impl.timers.skip_list_node.cljs$core$IFn$_invoke$arity$3 = function (k, v, level) {
  var arr = new Array(level + 1);
  var i_26230 = 0;

  while (true) {
    if (i_26230 < arr.length) {
      arr[i_26230] = null;
      var G__26231 = i_26230 + 1;
      i_26230 = G__26231;
      continue;
    } else {}

    break;
  }

  return new cljs.core.async.impl.timers.SkipListNode(k, v, arr);
};

cljs.core.async.impl.timers.skip_list_node.cljs$lang$maxFixedArity = 3;

cljs.core.async.impl.timers.least_greater_node = function cljs$core$async$impl$timers$least_greater_node(var_args) {
  var G__26214 = arguments.length;

  switch (G__26214) {
    case 3:
      return cljs.core.async.impl.timers.least_greater_node.cljs$core$IFn$_invoke$arity$3(arguments[0], arguments[1], arguments[2]);
      break;

    case 4:
      return cljs.core.async.impl.timers.least_greater_node.cljs$core$IFn$_invoke$arity$4(arguments[0], arguments[1], arguments[2], arguments[3]);
      break;

    default:
      throw new Error(["Invalid arity: ", cljs.core.str.cljs$core$IFn$_invoke$arity$1(arguments.length)].join(''));
  }
};

cljs.core.async.impl.timers.least_greater_node.cljs$core$IFn$_invoke$arity$3 = function (x, k, level) {
  return cljs.core.async.impl.timers.least_greater_node.cljs$core$IFn$_invoke$arity$4(x, k, level, null);
};

cljs.core.async.impl.timers.least_greater_node.cljs$core$IFn$_invoke$arity$4 = function (x, k, level, update) {
  while (true) {
    if (!(level < 0)) {
      var x__$1 = function () {
        var x__$1 = x;

        while (true) {
          var temp__5802__auto__ = level < x__$1.forward.length ? x__$1.forward[level] : null;

          if (cljs.core.truth_(temp__5802__auto__)) {
            var x_SINGLEQUOTE_ = temp__5802__auto__;

            if (x_SINGLEQUOTE_.key < k) {
              var G__26233 = x_SINGLEQUOTE_;
              x__$1 = G__26233;
              continue;
            } else {
              return x__$1;
            }
          } else {
            return x__$1;
          }

          break;
        }
      }();

      if (update == null) {} else {
        update[level] = x__$1;
      }

      var G__26234 = x__$1;
      var G__26235 = k;
      var G__26236 = level - 1;
      var G__26237 = update;
      x = G__26234;
      k = G__26235;
      level = G__26236;
      update = G__26237;
      continue;
    } else {
      return x;
    }

    break;
  }
};

cljs.core.async.impl.timers.least_greater_node.cljs$lang$maxFixedArity = 4;
/**
* @constructor
 * @implements {cljs.core.ISeqable}
 * @implements {cljs.core.IPrintWithWriter}
*/

cljs.core.async.impl.timers.SkipList = function (header, level) {
  this.header = header;
  this.level = level;
  this.cljs$lang$protocol_mask$partition0$ = 2155872256;
  this.cljs$lang$protocol_mask$partition1$ = 0;
};

cljs.core.async.impl.timers.SkipList.prototype.put = function (k, v) {
  var self__ = this;
  var coll = this;
  var update = new Array(cljs.core.async.impl.timers.MAX_LEVEL);
  var x = cljs.core.async.impl.timers.least_greater_node.cljs$core$IFn$_invoke$arity$4(self__.header, k, self__.level, update);
  var x__$1 = x.forward[0];

  if (!(x__$1 == null) && x__$1.key === k) {
    return x__$1.val = v;
  } else {
    var new_level = cljs.core.async.impl.timers.random_level.cljs$core$IFn$_invoke$arity$0();

    if (new_level > self__.level) {
      var i_26238 = self__.level + 1;

      while (true) {
        if (i_26238 <= new_level + 1) {
          update[i_26238] = self__.header;
          var G__26239 = i_26238 + 1;
          i_26238 = G__26239;
          continue;
        } else {}

        break;
      }

      self__.level = new_level;
    } else {}

    var x__$2 = cljs.core.async.impl.timers.skip_list_node.cljs$core$IFn$_invoke$arity$3(k, v, new Array(new_level));
    var i = 0;

    while (true) {
      if (i <= self__.level) {
        var links_26240 = update[i].forward;

        if (i < x__$2.forward.length) {
          x__$2.forward[i] = links_26240[i];
        } else {
          x__$2.forward.push(i < links_26240.length ? links_26240[i] : null);
        }

        if (i < links_26240.length) {
          links_26240[i] = x__$2;
        } else {
          links_26240.push(x__$2);
        }

        var G__26241 = i + 1;
        i = G__26241;
        continue;
      } else {
        return null;
      }

      break;
    }
  }
};

cljs.core.async.impl.timers.SkipList.prototype.remove = function (k) {
  var self__ = this;
  var coll = this;
  var update = new Array(cljs.core.async.impl.timers.MAX_LEVEL);
  var x = cljs.core.async.impl.timers.least_greater_node.cljs$core$IFn$_invoke$arity$4(self__.header, k, self__.level, update);
  var x__$1 = x.forward.length === 0 ? null : x.forward[0];

  if (!(x__$1 == null) && x__$1.key === k) {
    var i_26242 = 0;

    while (true) {
      if (i_26242 <= self__.level) {
        var links_26243 = update[i_26242].forward;

        if (x__$1 === (i_26242 < links_26243.length ? links_26243[i_26242] : null)) {
          links_26243[i_26242] = x__$1.forward[i_26242];
          var G__26244 = i_26242 + 1;
          i_26242 = G__26244;
          continue;
        } else {
          var G__26245 = i_26242 + 1;
          i_26242 = G__26245;
          continue;
        }
      } else {}

      break;
    }

    while (true) {
      if (0 < self__.level && self__.level < self__.header.forward.length && self__.header.forward[self__.level] == null) {
        self__.level = self__.level - 1;
        continue;
      } else {
        return null;
      }

      break;
    }
  } else {
    return null;
  }
};

cljs.core.async.impl.timers.SkipList.prototype.ceilingEntry = function (k) {
  var self__ = this;
  var coll = this;
  var x = self__.header;
  var level__$1 = self__.level;

  while (true) {
    if (!(level__$1 < 0)) {
      var nx = function () {
        var x__$1 = x;

        while (true) {
          var x_SINGLEQUOTE_ = level__$1 < x__$1.forward.length ? x__$1.forward[level__$1] : null;

          if (!(x_SINGLEQUOTE_ == null)) {
            if (x_SINGLEQUOTE_.key > k) {
              return x__$1;
            } else {
              var G__26246 = x_SINGLEQUOTE_;
              x__$1 = G__26246;
              continue;
            }
          } else {
            if (level__$1 === 0) {
              return x__$1;
            } else {
              return null;
            }
          }

          break;
        }
      }();

      if (cljs.core.truth_(nx)) {
        var G__26247 = nx;
        var G__26248 = level__$1 - 1;
        x = G__26247;
        level__$1 = G__26248;
        continue;
      } else {
        var G__26249 = x;
        var G__26250 = level__$1 - 1;
        x = G__26249;
        level__$1 = G__26250;
        continue;
      }
    } else {
      if (cljs.core._EQ_.cljs$core$IFn$_invoke$arity$2(x.key, k)) {
        return x;
      } else {
        return x.forward[0];
      }
    }

    break;
  }
};

cljs.core.async.impl.timers.SkipList.prototype.floorEntry = function (k) {
  var self__ = this;
  var coll = this;
  var x = self__.header;
  var level__$1 = self__.level;

  while (true) {
    if (!(level__$1 < 0)) {
      var nx = function () {
        var x__$1 = x;

        while (true) {
          var x_SINGLEQUOTE_ = level__$1 < x__$1.forward.length ? x__$1.forward[level__$1] : null;

          if (!(x_SINGLEQUOTE_ == null)) {
            if (x_SINGLEQUOTE_.key > k) {
              return x__$1;
            } else {
              var G__26251 = x_SINGLEQUOTE_;
              x__$1 = G__26251;
              continue;
            }
          } else {
            if (level__$1 === 0) {
              return x__$1;
            } else {
              return null;
            }
          }

          break;
        }
      }();

      if (cljs.core.truth_(nx)) {
        var G__26252 = nx;
        var G__26253 = level__$1 - 1;
        x = G__26252;
        level__$1 = G__26253;
        continue;
      } else {
        var G__26254 = x;
        var G__26255 = level__$1 - 1;
        x = G__26254;
        level__$1 = G__26255;
        continue;
      }
    } else {
      if (x === self__.header) {
        return null;
      } else {
        return x;
      }
    }

    break;
  }
};

cljs.core.async.impl.timers.SkipList.prototype.cljs$core$ISeqable$_seq$arity$1 = function (coll) {
  var self__ = this;
  var coll__$1 = this;

  var iter = function cljs$core$async$impl$timers$iter(node) {
    return new cljs.core.LazySeq(null, function () {
      if (node == null) {
        return null;
      } else {
        return cljs.core.cons(new cljs.core.PersistentVector(null, 2, 5, cljs.core.PersistentVector.EMPTY_NODE, [node.key, node.val], null), cljs$core$async$impl$timers$iter(node.forward[0]));
      }
    }, null, null);
  };

  return iter(self__.header.forward[0]);
};

cljs.core.async.impl.timers.SkipList.prototype.cljs$core$IPrintWithWriter$_pr_writer$arity$3 = function (coll, writer, opts) {
  var self__ = this;
  var coll__$1 = this;

  var pr_pair = function pr_pair(keyval) {
    return cljs.core.pr_sequential_writer(writer, cljs.core.pr_writer, "", " ", "", opts, keyval);
  };

  return cljs.core.pr_sequential_writer(writer, pr_pair, "{", ", ", "}", opts, coll__$1);
};

cljs.core.async.impl.timers.SkipList.getBasis = function () {
  return new cljs.core.PersistentVector(null, 2, 5, cljs.core.PersistentVector.EMPTY_NODE, [new cljs.core.Symbol(null, "header", "header", 1759972661, null), cljs.core.with_meta(new cljs.core.Symbol(null, "level", "level", -1363938217, null), new cljs.core.PersistentArrayMap(null, 1, [new cljs.core.Keyword(null, "mutable", "mutable", 875778266), true], null))], null);
};

cljs.core.async.impl.timers.SkipList.cljs$lang$type = true;
cljs.core.async.impl.timers.SkipList.cljs$lang$ctorStr = "cljs.core.async.impl.timers/SkipList";

cljs.core.async.impl.timers.SkipList.cljs$lang$ctorPrWriter = function (this__4369__auto__, writer__4370__auto__, opt__4371__auto__) {
  return cljs.core._write(writer__4370__auto__, "cljs.core.async.impl.timers/SkipList");
};
/**
 * Positional factory function for cljs.core.async.impl.timers/SkipList.
 */


cljs.core.async.impl.timers.__GT_SkipList = function cljs$core$async$impl$timers$__GT_SkipList(header, level) {
  return new cljs.core.async.impl.timers.SkipList(header, level);
};

cljs.core.async.impl.timers.skip_list = function cljs$core$async$impl$timers$skip_list() {
  return new cljs.core.async.impl.timers.SkipList(cljs.core.async.impl.timers.skip_list_node.cljs$core$IFn$_invoke$arity$1(0), 0);
};

cljs.core.async.impl.timers.timeouts_map = cljs.core.async.impl.timers.skip_list();
cljs.core.async.impl.timers.TIMEOUT_RESOLUTION_MS = 10;
/**
 * returns a channel that will close after msecs
 */

cljs.core.async.impl.timers.timeout = function cljs$core$async$impl$timers$timeout(msecs) {
  var timeout = new Date().valueOf() + msecs;
  var me = cljs.core.async.impl.timers.timeouts_map.ceilingEntry(timeout);
  var or__4126__auto__ = cljs.core.truth_(function () {
    var and__4115__auto__ = me;

    if (cljs.core.truth_(and__4115__auto__)) {
      return me.key < timeout + cljs.core.async.impl.timers.TIMEOUT_RESOLUTION_MS;
    } else {
      return and__4115__auto__;
    }
  }()) ? me.val : null;

  if (cljs.core.truth_(or__4126__auto__)) {
    return or__4126__auto__;
  } else {
    var timeout_channel = cljs.core.async.impl.channels.chan.cljs$core$IFn$_invoke$arity$1(null);
    cljs.core.async.impl.timers.timeouts_map.put(timeout, timeout_channel);
    cljs.core.async.impl.dispatch.queue_delay(function () {
      cljs.core.async.impl.timers.timeouts_map.remove(timeout);
      return cljs.core.async.impl.protocols.close_BANG_(timeout_channel);
    }, msecs);
    return timeout_channel;
  }
};

Object.defineProperty(module.exports, "__GT_SkipListNode", {
  enumerable: false,
  get: function get() {
    return cljs.core.async.impl.timers.__GT_SkipListNode;
  }
});
Object.defineProperty(module.exports, "timeout", {
  enumerable: false,
  get: function get() {
    return cljs.core.async.impl.timers.timeout;
  }
});
Object.defineProperty(module.exports, "random_level", {
  enumerable: false,
  get: function get() {
    return cljs.core.async.impl.timers.random_level;
  }
});
Object.defineProperty(module.exports, "SkipList", {
  enumerable: false,
  get: function get() {
    return cljs.core.async.impl.timers.SkipList;
  }
});
Object.defineProperty(module.exports, "skip_list", {
  enumerable: false,
  get: function get() {
    return cljs.core.async.impl.timers.skip_list;
  }
});
Object.defineProperty(module.exports, "__GT_SkipList", {
  enumerable: false,
  get: function get() {
    return cljs.core.async.impl.timers.__GT_SkipList;
  }
});
Object.defineProperty(module.exports, "MAX_LEVEL", {
  enumerable: false,
  get: function get() {
    return cljs.core.async.impl.timers.MAX_LEVEL;
  }
});
Object.defineProperty(module.exports, "P", {
  enumerable: false,
  get: function get() {
    return cljs.core.async.impl.timers.P;
  }
});
Object.defineProperty(module.exports, "timeouts_map", {
  enumerable: false,
  get: function get() {
    return cljs.core.async.impl.timers.timeouts_map;
  }
});
Object.defineProperty(module.exports, "SkipListNode", {
  enumerable: false,
  get: function get() {
    return cljs.core.async.impl.timers.SkipListNode;
  }
});
Object.defineProperty(module.exports, "skip_list_node", {
  enumerable: false,
  get: function get() {
    return cljs.core.async.impl.timers.skip_list_node;
  }
});
Object.defineProperty(module.exports, "least_greater_node", {
  enumerable: false,
  get: function get() {
    return cljs.core.async.impl.timers.least_greater_node;
  }
});
Object.defineProperty(module.exports, "TIMEOUT_RESOLUTION_MS", {
  enumerable: false,
  get: function get() {
    return cljs.core.async.impl.timers.TIMEOUT_RESOLUTION_MS;
  }
});